export function compareDates(date1, date2, operator) {
    function toDayNumber(date) {
        if (!date) return null;
        const d = (date instanceof Date) ? date : new Date(date);
        if (isNaN(d)) return null;
        // Erzeuge eine Zahl im Format JJJJMMTT, z.B. 20250604
        return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
    }

    const d1 = toDayNumber(date1);
    const d2 = toDayNumber(date2);

    switch (operator) {
        case '>':
            if (d1 == null) return true;
            if (d2 == null) return false;
            return d1 >= d2; // Änderung: >= statt >
        case '<':
            if (d1 == null || d2 == null) return false;
            return d1 < d2; // Änderung: <= statt <
        case '>=':
            if (d1 == null || d2 == null) return false;
            return d1 >= d2;
        case '<=':
            if (d1 == null || d2 == null) return false;
            return d1 <= d2;
        case '==':
            if (d1 == null || d2 == null) return false;
            return d1 === d2;
        case '!=':
            if (d1 == null || d2 == null) return true;
            return d1 !== d2;
        default:
            throw new Error(`Ungültiger Operator: ${operator}`);
    }
}